// extracted by mini-css-extract-plugin
export default {"rating":"sy-z","numberOfStars":"ty-z","count":"uy-z","barGraphSpacing":"vy-z","barGraph":"wy-z"};